import React from 'react';
import styles from './styles.scss';
const logoSvg = require('./apple-logo-white.svg') as string;

type Props = {
  href: string | undefined;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  isConnected: boolean;
  signOnText: string;
};

const Apple: React.FC<Props> = ({ href, isConnected, onClick, signOnText }) => {
  return (
    <a
      href={!isConnected ? href : undefined}
      className={styles.container}
      style={{
        cursor: isConnected ? 'default' : 'pointer',
        borderColor: '#000',
      }}
      onClick={onClick}
    >
      <div className={styles.innerContainer}>
        {!isConnected && <img src={logoSvg} width={20} />}
        <p style={{ marginLeft: 8, color: '#000' }}>
          {!isConnected ? signOnText : 'Connected'}
        </p>
      </div>
    </a>
  );
};

export default Apple;
